export const DownloadIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 10.875V3.375M9 10.875C8.47485 10.875 7.49365 9.37927 7.125 9M9 10.875C9.52515 10.875 10.5064 9.37927 10.875 9"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 12.375C15 14.2365 14.6115 14.625 12.75 14.625H5.25C3.3885 14.625 3 14.2365 3 12.375"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
